import { __awaiter, __generator } from "tslib";
import { Auth as AmplifyAuth } from 'aws-amplify';
import { logError } from '@one-vision/utils';
var adminPartnerId = -1;
var devPartnerId = 5319;
var lsPartnerId = 'selected-partner';
var Auth = /** @class */ (function () {
    function Auth(storage) {
        var _this = this;
        this.storage = storage;
        this.isAdmin = false;
        this.getIsAdmin = function () { return _this.isAdmin; };
        this.username = '';
        this.getUsername = function () { return _this.username; };
        this.activePartnerId = 0;
        this.getPartnerId = function () { return _this.activePartnerId; };
        this._authorized = false;
        this.setPartnerId = function (partnerId) {
            if (_this.activePartnerId !== partnerId) {
                _this.activePartnerId = partnerId;
            }
            _this.storage.save(lsPartnerId, _this.activePartnerId.toString());
        };
        this.clearPartnerId = function () {
            _this.storage.remove(lsPartnerId);
        };
    }
    Object.defineProperty(Auth.prototype, "authorized", {
        get: function () {
            return this._authorized;
        },
        enumerable: false,
        configurable: true
    });
    Auth.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var session, savedPartnerId, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, AmplifyAuth.currentSession()];
                    case 1:
                        session = _a.sent();
                        this.username = session.getAccessToken().payload.username;
                        this.activePartnerId = this.partnerIdFromTokenPayload(session.getAccessToken().payload);
                        this.isAdmin = this.activePartnerId === adminPartnerId;
                        if (this.isAdmin) {
                            savedPartnerId = this.storage.get(lsPartnerId);
                            this.activePartnerId = savedPartnerId
                                ? parseInt(savedPartnerId, 10)
                                : devPartnerId;
                        }
                        this._authorized = true;
                        return [2 /*return*/, true];
                    case 2:
                        error_1 = _a.sent();
                        logError(error_1);
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Auth.prototype.partnerIdFromTokenPayload = function (payload) {
        var groups = payload['cognito:groups'];
        var partnerId = (groups === null || groups === void 0 ? void 0 : groups.pop()) || '';
        return parseInt(partnerId, 10);
    };
    Auth.prototype.getToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var session, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, AmplifyAuth.currentSession()];
                    case 1:
                        session = _a.sent();
                        return [2 /*return*/, session.getAccessToken().getJwtToken()];
                    case 2:
                        error_2 = _a.sent();
                        this.signOut();
                        // This is unreachable but is left for typing consistency.
                        return [2 /*return*/, ''];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Auth.prototype.signOut = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this._authorized = false;
                this.storage.save(lsPartnerId, '');
                AmplifyAuth.signOut();
                return [2 /*return*/];
            });
        });
    };
    return Auth;
}());
var defaultAuthStorage = {
    save: function (key, value) { return localStorage.setItem(key, value); },
    get: function (key) { return localStorage.getItem(key); },
    remove: function (key) { return localStorage.removeItem(key); },
};
export var auth = new Auth(defaultAuthStorage);
